import { FILIAIS_TOURS } from './filiais.tour';
import { CADASTROS_COMPLEMENTARES_TOURS } from './cadastros-complementares.tour';
import { CONTRATOS_TOURS } from './contratos.tour';
import { DOCUMENTOS_ADMINISTRATIVOS_FORMULARIO_TOURS } from './documentos-administrativos-formulario.tour';
import { SUPORTE_COMPLEMENTAR_TOURS } from './suporte-complementar.tour';
import { OPERACOES_FINANCEIRAS_TOURS } from './operacoes-financeiras.tour';
import { GOVERNANCA_TOURS } from './governanca.tour';
import { CONFIGURACOES_GERAIS_TOURS } from './configuracoes-gerais.tour';
import { PARAMETROS_TOURS } from './parametros.tour';
import { PERFIL_IA_TOURS } from './perfil-ia.tour';
import { MCP_TOURS } from './mcp.tour';
import { MIGRACAO_TOURS } from './migracao.tour';
import { PAGAMENTOS_GERENCIAR_TOURS } from './pagamentos-gerenciar.tour';
import { COBRANCA_CONFIGURACAO_TOURS } from './cobranca-configuracao.tour';
import { CADASTROS_CONSULTA_TOURS, USUARIOS_ACESSO_TOUR } from './cadastros-consulta.tour';
import { RECEBIMENTOS_CONFIGURACAO_TOURS } from './recebimentos-configuracao.tour';
import { COBRANCA_EMISSAO_TOURS } from './cobranca-emissao.tour';
import { FISCAL_CONFIGURACAO_TOURS } from './fiscal-configuracao.tour';
import { NOTAS_FISCAIS_TOURS } from './notas-fiscais.tour';
import { RELATORIOS_TOURS } from './relatorios.tour';
import { PLANILHAS_CONTABEIS_TOURS } from './planilhas-contabeis.tour';
import { DOCUMENTOS_FINANCEIROS_TOURS } from './documentos-financeiros.tour';
import { CREDITOS_TOUR } from './creditos.tour';
import { SUPORTE_TOURS } from './suporte.tour';
import { HISTORICO_ACOES_TOURS } from './historico-acoes.tour';
import { CONTADOR_TOUR } from './contador.tour';
import { Tutorial } from '../tutorial.model';
import { CONTAS_PAGAR_PAGAMENTO_TOUR, CONTA_PAGAR_PAGAMENTO_TOUR, CONTA_PAGAR_VISUALIZACAO_TOUR } from './pagamento.tour';
import { CONTAS_RECEBER_TOUR, CONTAS_RECEBER_RECEBIMENTO_TOUR, CONTA_RECEBER_RECEBIMENTO_TOUR, CONTA_RECEBER_VISUALIZACAO_TOUR } from './recebimento.tour';
import { CONTA_RECEBER_CADASTRO_TOUR, CONTA_RECEBER_EDICAO_TOUR, CONTA_RECEBER_ARQUIVO_TOUR, CONTA_RECEBER_XML_TOUR, CONTA_RECEBER_IMPORTACAO_TOUR } from './contas-receber-cadastro.tour';
import { CONTAS_RECEBER_RECORRENCIA_TOUR, CONTA_RECEBER_RECORRENCIA_TOUR, CONTA_RECEBER_RECORRENTE_TOUR } from './recorrencia.tour';
import { CONTAS_PAGAR_CONSULTA_TOUR, CONTAS_PAGAR_TOUR, CONTA_PAGAR_CADASTRO_TOUR, CONTA_PAGAR_EDICAO_TOUR, CONTA_PAGAR_ARQUIVO_TOUR, CONTA_PAGAR_XML_TOUR, CONTA_PAGAR_IMPORTACAO_TOUR } from './contas-pagar.tour';
import { LPS_GERENCIAR_TOUR } from './lps-gerenciar.tour';
import { LPS_LISTA_TOUR } from './lps-lista.tour';
import { LP_CADASTRO_TOUR, LP_EDICAO_TOUR } from './lp-cadastro.tour';
import { CATEGORIAS_TOUR } from './categorias.tour';
import { CATEGORIA_CADASTRO_TOUR } from './categoria-cadastro.tour';
import { CATEGORIAS_TRIBUTACAO_TOUR, CATEGORIA_TRIBUTACAO_CADASTRO_TOUR } from './categoria-tributacao.tour';
import { CARGO_CADASTRO_TOUR, CARGO_EDICAO_TOUR } from './cargo-cadastro.tour';
import { CAIXAS_TOUR, CAIXA_CADASTRO_TOUR, CAIXA_EDICAO_TOUR, CAIXA_CADASTRO_DIALOGO_TOUR, CAIXA_EDICAO_DIALOGO_TOUR, CAIXA_HISTORICO_TOUR, CAIXA_TRANSFERENCIA_TOUR } from './caixas.tour';
import { CLIENTE_CADASTRO_TOUR, CLIENTE_EDICAO_TOUR } from './cliente-cadastro.tour';
import { CLIENTE_FICHA_TOUR } from './cliente-ficha.tour';
import { CLIENTES_TOUR } from './clientes.tour';
import { DASHBOARD_TOUR } from './dashboard.tour';
import { DOCUMENTOS_TOUR } from './documentos.tour';
import { PESSOA_CADASTRO_TOUR, PESSOA_EDICAO_TOUR } from './pessoa-cadastro.tour';
import { FORNECEDOR_CADASTRO_TOUR, FORNECEDOR_EDICAO_TOUR } from './fornecedor-cadastro.tour';
import { USUARIO_CADASTRO_TOUR, USUARIO_EDICAO_TOUR } from './usuario-cadastro.tour';
import { IMPORTACAO_LPS_TOUR, IMPORTACAO_LPS_CONFERENCIA_TOUR } from './importacao-lps.tour';

/**
 * O registro de tours. Tour novo entra AQUI e em lugar nenhum mais — quem
 * resolve "qual tour é o desta rota" é a função abaixo, e ela lê só esta lista.
 */
export const TOURS: readonly Tutorial[] = [
  ...PAGAMENTOS_GERENCIAR_TOURS,
  ...COBRANCA_CONFIGURACAO_TOURS,
  ...CADASTROS_CONSULTA_TOURS,
  USUARIOS_ACESSO_TOUR,
  ...RECEBIMENTOS_CONFIGURACAO_TOURS,
  ...COBRANCA_EMISSAO_TOURS,
  ...FISCAL_CONFIGURACAO_TOURS,
  ...NOTAS_FISCAIS_TOURS,
  ...RELATORIOS_TOURS,
  ...PLANILHAS_CONTABEIS_TOURS,
  ...DOCUMENTOS_FINANCEIROS_TOURS,
  CREDITOS_TOUR,
  ...SUPORTE_TOURS,
  ...HISTORICO_ACOES_TOURS,
  CONTADOR_TOUR,

  DASHBOARD_TOUR,
  CONTAS_RECEBER_RECEBIMENTO_TOUR,
  CONTAS_RECEBER_RECORRENCIA_TOUR,
  CONTA_RECEBER_RECORRENCIA_TOUR,
  CONTA_RECEBER_RECORRENTE_TOUR,
  CONTAS_RECEBER_TOUR,
  CONTA_RECEBER_RECEBIMENTO_TOUR,
  CONTA_RECEBER_VISUALIZACAO_TOUR,
  CONTA_RECEBER_CADASTRO_TOUR,
  CONTA_RECEBER_EDICAO_TOUR,
  CONTA_RECEBER_ARQUIVO_TOUR,
  CONTA_RECEBER_XML_TOUR,
  CONTA_RECEBER_IMPORTACAO_TOUR,
  CONTAS_PAGAR_PAGAMENTO_TOUR,
  CONTAS_PAGAR_CONSULTA_TOUR,
  CONTAS_PAGAR_TOUR,
  CONTA_PAGAR_PAGAMENTO_TOUR,
  CONTA_PAGAR_VISUALIZACAO_TOUR,
  CONTA_PAGAR_CADASTRO_TOUR,
  CONTA_PAGAR_EDICAO_TOUR,
  CONTA_PAGAR_ARQUIVO_TOUR,
  CONTA_PAGAR_XML_TOUR,
  CONTA_PAGAR_IMPORTACAO_TOUR,
  CLIENTES_TOUR,
  CLIENTE_CADASTRO_TOUR,
  CLIENTE_EDICAO_TOUR,
  CLIENTE_FICHA_TOUR,
  DOCUMENTOS_TOUR,
  PESSOA_CADASTRO_TOUR,
  PESSOA_EDICAO_TOUR,
  CARGO_CADASTRO_TOUR,
  CARGO_EDICAO_TOUR,
  CAIXAS_TOUR,
  CAIXA_CADASTRO_TOUR,
  CAIXA_EDICAO_TOUR,
  CAIXA_CADASTRO_DIALOGO_TOUR,
  CAIXA_EDICAO_DIALOGO_TOUR,
  CAIXA_HISTORICO_TOUR,
  CAIXA_TRANSFERENCIA_TOUR,
  FORNECEDOR_CADASTRO_TOUR,
  FORNECEDOR_EDICAO_TOUR,
  USUARIO_CADASTRO_TOUR,
  USUARIO_EDICAO_TOUR,
  IMPORTACAO_LPS_TOUR,
  IMPORTACAO_LPS_CONFERENCIA_TOUR,
  LPS_GERENCIAR_TOUR,
  LPS_LISTA_TOUR,
  LP_CADASTRO_TOUR,
  LP_EDICAO_TOUR,
  CATEGORIAS_TRIBUTACAO_TOUR,
  CATEGORIA_TRIBUTACAO_CADASTRO_TOUR,
  CATEGORIAS_TOUR,
  CATEGORIA_CADASTRO_TOUR,
  ...FILIAIS_TOURS,
  ...CADASTROS_COMPLEMENTARES_TOURS,
  ...CONTRATOS_TOURS,
  ...DOCUMENTOS_ADMINISTRATIVOS_FORMULARIO_TOURS,
  ...SUPORTE_COMPLEMENTAR_TOURS,
  ...OPERACOES_FINANCEIRAS_TOURS,
  ...GOVERNANCA_TOURS,
  ...CONFIGURACOES_GERAIS_TOURS,
  ...PARAMETROS_TOURS,
  ...PERFIL_IA_TOURS,
  ...MCP_TOURS,
  ...MIGRACAO_TOURS,
];

export function tourPorId(id: string): Tutorial | null {
  return TOURS.find(tour => tour.id === id) ?? null;
}

/**
 * Qual tour pertence à URL do `Router`.
 *
 * A comparação é EXATA sobre o caminho (query e fragmento saem antes:
 * `/painel/dashboard?competencia=2026-09` continua sendo o painel).
 *
 * Era por prefixo, e isso fazia o tour da LISTAGEM de clientes disparar na
 * ficha (`/clientes/<id>`) e no cadastro (`/clientes/criar`), pulando os
 * passos sem alvo — medido em 05/09/2026 na revisão da tela de clientes.
 * Ficha e cadastro são telas diferentes, e desde 06/09/2026 têm tour próprio.
 *
 * Uma rota de tour pode trazer parâmetro (`/clientes/:id/editar`), porque a
 * ficha e a edição só existem com id na URL. Rota literal é testada ANTES da
 * rota com parâmetro — ver `casaComParametro`.
 */
export function tourDaRota(url: string): Tutorial | null {
  const caminho = url.split(/[?#]/)[0].replace(/\/+$/, '');
  const parametros = new URLSearchParams(url.split('?')[1]?.split('#')[0] ?? '');
  const aplicaveis = TOURS.filter(tour => !tour.dialogo && Object.entries(tour.parametros ?? {})
    .every(([chave, valor]) => parametros.get(chave) === valor))
    .sort((a, b) => Object.keys(b.parametros ?? {}).length - Object.keys(a.parametros ?? {}).length);
  const literais = aplicaveis.filter(tour => !tour.rota.includes('/:'));
  const comParametro = aplicaveis.filter(tour => tour.rota.includes('/:'));

  // Literal PRIMEIRO, e isso não é detalhe: `/clientes/:id` casaria com
  // `/clientes/criar`, e o cadastro receberia o tour da ficha. Rota sem
  // parâmetro é sempre mais específica que rota com parâmetro.
  return literais.find(tour => caminho === tour.rota)
    ?? comParametro.find(tour => casaComParametro(caminho, tour.rota))
    ?? null;
}

/**
 * Casa a URL com uma rota que tem parâmetro, segmento a segmento.
 *
 * Um segmento que começa com `:` casa com QUALQUER segmento, e só um — é o
 * mesmo contrato do `Router` do Angular, para o autor do tour escrever
 * `/painel/listagem/clientes/:id/editar` e não precisar aprender outra
 * gramática. Sem isto, tela com id na URL (ficha e edição) não pode ter tour:
 * a comparação exata que existia nunca casaria.
 */
export function casaComParametro(caminho: string, rota: string): boolean {
  const doCaminho = caminho.split('/');
  const daRota = rota.split('/');

  return (
    doCaminho.length === daRota.length &&
    daRota.every((segmento, i) => (segmento.startsWith(':') ? doCaminho[i].length > 0 : segmento === doCaminho[i]))
  );
}
